import { type ReactNode } from "react";
import { cn } from "@/lib/utils";

export function Empty({
  children,
  block = false,
  className,
}: {
  children: ReactNode;
  block?: boolean;
  className?: string;
}) {
  if (block) {
    return <p className={cn("text-xs text-slate-500", className)}>{children}</p>;
  }
  return <span className={cn("text-slate-400", className)}>{children}</span>;
}
